import React from 'react';
import { connect } from 'react-redux';

import { colors } from '@styleseat/brand';
import withStore from '../../../withStore';
import NotificationBanner from '../NotificationBanner';
import { useMount } from '../../../../hooks';
import analytics from '../../../../modules/analytics';

import ICON from '../../../../../images/icons/icon-thunder.svg';

type ServiceInteractionNotificationProps = {
  notification: NotificationObject;
  linkTo: (string, any, bool?) => void;
};

type NotificationObject = {
  type: string,
  provider_id: number;
  service_id: number;
  service_name: string;
  interactions: number;
  has_description?: boolean;
};

const TRACKING_PREFIX = 'pro_notifications';

export const ServiceInteractionNotification: React.FC<ServiceInteractionNotificationProps> = ({
  notification,
  linkTo,
}) => {
  const {
    provider_id: providerId,
    service_id: serviceId,
    service_name: serviceName,
    interactions,
    has_description: hasDescription,
  } = notification;

  const {
    highlightedSubText,
    subText,
    viewEvent,
    clickEvent,
    extraClickParams,
    route,
    buttonText,
  } = hasDescription ? {
    highlightedSubText: 'Great job!',
    subText: 'continue building your business and promote your profile!',
    viewEvent: `${TRACKING_PREFIX}_clients_viewed_services_view`,
    clickEvent: `${TRACKING_PREFIX}_clients_viewed_services_promote_clicked`,
    extraClickParams: {},
    route: 'responsive.provider.promote',
    buttonText: 'promote profile',
  } : {
    highlightedSubText: 'Add a description',
    subText: 'to your service so clients know what to expect when booking',
    viewEvent: `${TRACKING_PREFIX}_more_service_info_view`,
    clickEvent: `${TRACKING_PREFIX}_more_service_info_edit_click`,
    extraClickParams: {
      serviceId,
    },
    route: 'responsive.provider.services.edit_services',
    buttonText: 'add service description',
  };
  const timeText = interactions > 2 ? 'this week' : 'today';

  const clickTracking = {
    name: clickEvent,
    params: {
      providerId,
      serviceName,
      interactions,
    },
  };

  const buttonProps = {
    text: buttonText,
    clickTracking,
    appearance: 'text-light',
    size: 'small',
    onClick: () => {
      linkTo(route, {
        providerId,
        source: 'notification',
        ...extraClickParams,
      });
    },
  };

  useMount(() => {
    analytics.track(viewEvent, {
      providerId,
      serviceName,
      interactions,
    });
  });

  return (
    <NotificationBanner
      notification={notification}
      icon={ICON}
      iconSize={36}
      highlightedText={`Clients viewed your service "${serviceName}" ${interactions} time${interactions > 1 ? 's' : ''} ${timeText}`}
      highlightBorderColor={colors.sunshine}
      highlightedSubText={highlightedSubText}
      subText={subText}
      buttonProps={buttonProps}
    />
  );
};

const mapDispatchToProps = dispatch => ({
  linkTo: (route, params, notify = true) => {
    dispatch.route.go({
      route,
      params,
      notify,
    });
  },
});

export default withStore(connect(null, mapDispatchToProps)(ServiceInteractionNotification));
